import {
  EncounterSummaryControllerApi,
  ExportClinicalDataToEncounterTypeEnum,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * Export (link) selected existing clinical records of a given type
 * (allergy, medical/surgical/family history, medication) to an encounter.
 *
 * Backend: PUT /api/master/encounter-summary/export-clinical/{type}/{appointmentUuid}
 */
export const useExportClinicalToEncounter = () =>
  useMutationWithLoading(
    async (params: {
      type: ExportClinicalDataToEncounterTypeEnum;
      appointmentUuid: string;
      recordUuids: string[];
      xTENANTID?: string;
    }) =>
      new EncounterSummaryControllerApi(
        getConfigObject()
      ).exportClinicalDataToEncounter(
        params.type,
        params.appointmentUuid,
        // Generated type is Set<string> but the request is serialized via
        // JSON.stringify, so a plain array is what the backend expects.
        params.recordUuids as unknown as Set<string>,
        params.xTENANTID
      )
  );
